var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"select-box"},[_c('ul',_vm._l((_vm.options),function(item,index){return _c('li',{key:index,staticClass:"text-select",class:{'active': _vm.defaultVal===item.value},on:{"click":function($event){return _vm.$emit('change', item)}}},[_vm._v(_vm._s(item.value))])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }